jQuery(document).ready(function($){

	var Offices = {
		formAddress: $('#bh-sl-address'),
		formDistance: $('#bh-sl-maxdistance'),
		formRegion: $('#bh-sl-region'),
		userAddress: $('#jq-offices-postal'),
		userDistance: $('#jq-offices-distance'),
		userRegion: $('#jq-offices-region')
	};

	Offices.init = function() {
		Offices.userRegion.change(Offices.regionChange); // event musí být navázaný dřív než storeLocator

		$('#map-container').storeLocator({
			lengthUnit: 'km',
			dataType: 'json',
			dataLocation: urlPath + 'offices/locations.json',
			infowindowTemplatePath: urlPath + 'offices/infowindow-description.php',
			listTemplatePath: urlPath + 'offices/location-list-description.php',
			slideMap: false,
			fullMapStart: true,
			maxDistance: true,
			maxDistanceID: 'bh-sl-maxdistance',
			//defaultLoc: true,
			//defaultLat: 15.3498882,
			//defaultLng: 49.8200446,
			markerImg: urlPath + 'images/gmap-marker.png',
			markerDim: {width: 50, height: 60},
			listColor1: 'transparent',
			listColor2: 'transparent',
			distanceAlert: -1,
			storeLimit: -1,
			mapSettings: {
				zoom       : 0,
				mapTypeId  : google.maps.MapTypeId.ROADMAP,
				scrollwheel: false
			},
			taxonomyFilters: {
				'region' : 'jq-offices-region-filter'
			},
			callbackNoResults: Offices.noResult
		});

		$('#jq-offices-autolocation').click(Offices.autolocation);
		$('#jq-offices-submit').click(Offices.postalSearch);
		Offices.userDistance.change(Offices.distanceChange);

	};

	Offices.autolocation = function() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position){

				Offices.formAddress.val(position.coords.latitude + ', ' + position.coords.longitude);
				Offices.formDistance.val(Offices.getDistance());
				Offices.userAddress.val('');
				Offices.submitSearch();

				//$('#map-container').storeLocator('autoGeocodeQuery', position);

			}, function(){
				alert('Prohlížeči se nepodařilo určit vaši polohu.');
			});
		} else {
			alert('Váš prohlížeč nepodporuje funkci zjišťování polohy.');
		}
	};

	Offices.submitSearch = function() {
		$('#bh-sl-user-location').submit();
	}

	Offices.postalSearch = function() {
		if (Offices.userAddress.val() != '') {
			Offices.formDistance.val(Offices.getDistance());
			Offices.formAddress.val(Offices.userAddress.val());

			if (Offices.userRegion.val() != '') { // Pokud byl zadán kraj, tak ho změní
				Offices.userRegion.val('');
				Offices.userRegion.change();
			} else
				Offices.submitSearch();
		}
	}

	Offices.regionChange = function() {
		var regionID = Offices.userRegion.val();

		if (regionID != '') {
			Offices.formAddress.val('Česká Republika');
			Offices.formDistance.val('1000');
			Offices.userAddress.val('');
			Offices.submitSearch();
		}
	}

	Offices.distanceChange = function() {
		var newDistance = Offices.getDistance();
		var actualDistance = Offices.formDistance.val();
		var actualAddress = Offices.formAddress.val();

		if (actualDistance != 1000 && actualAddress != '') {
			Offices.formDistance.val(newDistance);
			if (Offices.userAddress.val() != '')
				Offices.formAddress.val(Offices.userAddress.val());

			Offices.submitSearch();
		}

	}

	Offices.getDistance = function() {
		return Offices.userDistance.find('option:selected').val();
	}

	Offices.noResult = function() {
		var actualRegion = Offices.userRegion.val();
		var actualAddress = Offices.formAddress.val();
		var actualDistance = Offices.formDistance.val();

		if (actualRegion == '') { // Nic nenalezeno po zadání PSČ a distance
			alert('Bohužel nemáme žádnou pobočku, která by odpovídala zadaným parametrům.');
			Offices.formAddress.val('Česká Republika');
			Offices.formDistance.val('1000');
			Offices.userAddress.val('');
			Offices.submitSearch();
		} else if (actualAddress == 'Česká Republika' && actualDistance == 1000) { // Nic nenalezeno v daném regionu
			alert('Bohužel nemáme žádnou pobočku, která by odpovídala zadaným parametrům.');
			Offices.userRegion.val('');
			Offices.userRegion.change();
		}
	}

	if (typeof google !== 'undefined') {
		loadJS('//cdn.jsdelivr.net/handlebarsjs/3.0.3/handlebars.min.js',function(){
			loadJS('js/jquery.storelocator.js',function(){
				Offices.init();
			});
		});
	}
});